"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRowWidget = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var inversify_react_1 = require("inversify-react");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var lodash_1 = require("lodash");
var TableBackgroundProvider_1 = require("./TableBackgroundProvider");
var TableRowWidgetInner = function (_a) {
    var isTableHeader = _a.isTableHeader, attributes = _a.attributes, children = _a.children;
    return (react_1.default.createElement("tr", __assign({ className: (0, classnames_1.default)({
            "table-header-row": isTableHeader,
        }) }, attributes), children));
};
var TableRowWidget = function (_a) {
    var element = _a.element, attributes = _a.attributes, children = _a.children;
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var path = widgetManager.getPath(element);
    var isTableHeader = (0, lodash_1.last)(path) === 0;
    return (react_1.default.createElement(TableBackgroundProvider_1.TableBackgroundProvider, { isTableHeader: isTableHeader },
        react_1.default.createElement(TableRowWidgetInner, { element: element, attributes: attributes, children: children, isTableHeader: isTableHeader })));
};
exports.TableRowWidget = TableRowWidget;
